import { useState } from "react";

import "./style.scss";
import { ThemeContainer } from "../../common/containers/theme/theme.container";
import { getLogoImg } from "../../common/utilities/logo/logo.util";
import { lightTheme, darkTheme } from "../../common/utilities/routes/routes.util";
import { SelectionFilter } from "../../components/menu-filter/menu-filter.comp";
import HeaderLayout from "../../components/layout/header-layout.comp";
import { Button } from "@mui/material";

const CustomizationView = () => {
    const { logo, color, theme, changeTheme } = ThemeContainer.useContainer();
    const [themeList] = useState<string[]>([lightTheme, darkTheme]);

    const handleThemeChange = (newTheme: string) => {
        if (theme !== newTheme) {
            changeTheme();
        }
    };

    const handleSaveClick = () => {
        //  TODO API will be added
    };

    return (
        <HeaderLayout
            blurHeader={false}
            subheaderHeight={46}
            subheader={
                <div className="customization-header">
                    <div className="customization-header-title">
                        <span className="customization-header-title__text">Customization</span>
                    </div>
                </div>
            }
            footerHeight={60}
            footer={
                <div style={{ height: 60 }} className="customization-footer">
                    <Button className="primary-button" variant="outlined" onClick={handleSaveClick}>
                        Save
                    </Button>
                </div>
            }
        >
            <div className="customization-view">
                <div className="customization-content">
                    <div className="customization-logo" style={{ backgroundColor: color }}>
                        <img src={getLogoImg(logo, true)} alt="" />
                    </div>
                    <div className="customization-item">
                        <div className="customization-item-title">
                            <span className="customization-item-title__text">Color Theme:</span>
                        </div>
                        <div className="customization-item-select">
                            <SelectionFilter
                                list={themeList}
                                selectedItem={theme.firstLetterToUppercase()}
                                setSelectedItem={handleThemeChange}
                                rightPosition={true}
                                minWidth={180}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </HeaderLayout>
    );
};

export default CustomizationView;
